import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useClaimMembership } from "../lib/proofers";

/**
 * `/claim/:token` — a signed-in proofer binds their own account using the
 * one-time link their admin sent. This is the path that needs NO Clerk secret
 * and no `email` claim on the session token: the link itself is the proof.
 * On success we land them straight on My Work.
 */
export function ClaimInvite() {
  const { token = "" } = useParams();
  const nav = useNavigate();
  const claim = useClaimMembership();
  const [error, setError] = useState<string | null>(null);
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current || !token) return;
    fired.current = true;               // StrictMode double-invokes effects
    claim.mutate(token, {
      onSuccess: () => setTimeout(() => nav("/my-work", { replace: true }), 600),
      onError: (e: unknown) => setError((e as Error)?.message || "That link didn't work."),
    });
  }, [token, claim, nav]);

  return (
    <div className="pl-page">
      <header className="pl-head">
        <h1>{error ? "We couldn't link that" : "Linking your account…"}</h1>
        <p className="muted">
          {error
            ? "Ask your admin for a fresh link — each one can only be used once."
            : "One moment — connecting you to the work you've been assigned."}
        </p>
      </header>
      {error && <div className="pl-empty">{error}</div>}
    </div>
  );
}
